import { render, staticRenderFns } from "./Veterinarias.vue?vue&type=template&id=a2bd30a4&scoped=true&"
import script from "./Veterinarias.vue?vue&type=script&lang=js&"
export * from "./Veterinarias.vue?vue&type=script&lang=js&"
import style0 from "./Veterinarias.vue?vue&type=style&index=0&id=a2bd30a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bd30a4",
  null
  
)

export default component.exports